<template>
    <div class="p-grid">
        <div class="p-col-12">
            <div class="card p-shadow-1">
                <h5>Logs de Operações dos Usuários</h5>
                <hr>

                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-2">
                        <label>Data início <span class="obrigatorio">*</span></label>
                        <Calendar v-model="dataInicio" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy"
                            :class="{ 'p-invalid': erros.dataInicio }" />
                        <small class="p-error" v-if="erros.dataInicio">Campo obrigatório.</small>
                    </div>
                    <div class="p-field p-col-12 p-md-2">
                        <label>Data final <span class="obrigatorio">*</span></label>
                        <Calendar v-model="dataFinal" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy"
                            :class="{ 'p-invalid': erros.dataFinal }" />
                        <small class="p-error" v-if="erros.dataFinal">Campo obrigatório.</small>
                    </div>
                    <div class="p-field p-col-12 p-md-3">
                        <label>Usuário</label>
                        <Dropdown v-model="usuarioId" :options="usuarios" optionLabel="nomeExibicao" optionValue="id"
                            placeholder="Selecione" :showClear="true" />
                    </div>
                    <div class="p-field p-col-0">
                        <label style="color: transparent">.</label>
                        <Button label="Buscar" icon="pi pi-search" @click="buscar" />
                    </div>
                </div>

                <DataTable :value="logs" class="p-datatable-sm p-datatable-striped">
                    <template #empty>
                        Nenhum registro encontrado.
                    </template>
                    <Column field="data" header="Data / Hora">
                        <template #body="slotProps">
                            {{ slotProps.data.data ? new Date(slotProps.data.data).toLocaleString('pt-BR') : '' }}
                        </template>
                    </Column>
                    <Column field="usuario.nome" header="Usuário"></Column>
                    <Column field="acao" header="Ação"></Column>
                </DataTable>

                <Paginator :rows="totalPorPagina" :totalRecords="totalItens" :rowsPerPageOptions="[30]"
                    template="FirstPageLink PrevPageLink CurrentPageReport NextPageLink LastPageLink"
                    currentPageReportTemplate="Listando {first} a {last} de {totalRecords}"
                    @page="paginar($event)" />
            </div>
        </div>
    </div>
</template>

<script>
import ClienteIKAcessoService from '@/service/ClienteIKAcessoService';
import { exibirMensagem } from '@/global';

export default {
    data() {
        return {
            dataInicio: new Date(),
            dataFinal: new Date(),
            usuarioId: null,
            usuarios: [],
            logs: [],
            totalItens: 0,
            totalPorPagina: 30,
            pagina: 0,
            erros: {
                dataInicio: false,
                dataFinal: false,
            },
        };
    },
    methods: {
        validar() {
            this.erros.dataInicio = !this.dataInicio;
            this.erros.dataFinal = !this.dataFinal;
            return !this.erros.dataInicio && !this.erros.dataFinal;
        },
        formatarData(data) {
            if (!data) return null;
            const d = new Date(data);
            const dia = String(d.getDate()).padStart(2, '0');
            const mes = String(d.getMonth() + 1).padStart(2, '0');
            const ano = d.getFullYear();
            return `${ano}-${mes}-${dia}`;
        },
        carregarUsuarios() {
            this.clienteService.listarUsuarios()
                .then(resp => {
                    this.usuarios = resp.data.map(u => ({
                        ...u,
                        nomeExibicao: `${u.nome} (${u.perfilAcesso})`,
                    }));
                })
                .catch(erro => { exibirMensagem(this, erro); });
        },
        buscar() {
            if (!this.validar()) return;
            this.pagina = 0;
            this.totalItens = 0;
            this.listar();
        },
        paginar(event) {
            this.pagina = event.page;
            this.totalPorPagina = event.rows;
            this.listar();
        },
        listar() {
            this.clienteService.listarLogsUsuariosOperacoes(
                this.formatarData(this.dataInicio),
                this.formatarData(this.dataFinal),
                this.usuarioId,
                this.pagina,
                this.totalPorPagina
            )
                .then(resp => {
                    this.totalItens = resp.data.totalItens;
                    this.logs = resp.data.logs;
                })
                .catch(erro => { exibirMensagem(this, erro); });
        },
    },
    created() {
        this.clienteService = new ClienteIKAcessoService();
    },
    mounted() {
        this.carregarUsuarios();
    },
};
</script>

<style scoped>
.obrigatorio {
    color: #e24c4c;
}
</style>
